import { IconStatus } from '@/shared/utils'
import { DisputStatus } from './types'

export const DisputStatusTitles: Record<DisputStatus, string> = {
  [DisputStatus.Created]: 'Ожидает принятия',
  [DisputStatus.InProgress]: 'Спор активен',
  [DisputStatus.Rejected]: 'Спор отклонён',
  [DisputStatus.Reopened]: 'Повторно открытый спор',
  [DisputStatus.Satisfied]: 'Спор завершён',
  [DisputStatus.Underfined]: 'Неизвестный статус',
  [DisputStatus.Returned]: '',
}

export const DisputStatusIcons: Record<DisputStatus, IconStatus> = {
  [DisputStatus.Created]: 'yellow',
  [DisputStatus.InProgress]: 'purple',
  [DisputStatus.Rejected]: 'red',
  [DisputStatus.Reopened]: 'yellow',
  [DisputStatus.Returned]: 'grey',
  [DisputStatus.Satisfied]: 'green',
  [DisputStatus.Underfined]: 'grey',
}
